import axios from "axios";
import { getHeaders, checkStatus } from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";

const baseURL = process.env.REACT_APP_BASE_URL;
 

  export async function getAsset(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Org/Inventory/List`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }

  export async function addAsset(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Org/Inventory/Add`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }

    export async function deleteAsset(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Org/Inventory/Asset/Delete`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }

    export async function assignedAsset(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Org/Inventory/Asset/Assigned`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }

    export async function addDocAsset(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Org/Inventory/Asset/Doc`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }

    export async function addNoteAsset(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Org/Inventory/Asset/Note/Add`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }